import Vue from "vue";
import Vuetify from "vuetify/lib";
import i18n from "./i18n";
import "../../sass/overrides.sass";
import "vuetify/dist/vuetify.min.css";

Vue.use(Vuetify);

const opts = {
	lang: {
		t: (key, ...params) => i18n.t(key, params),
	},
	theme: {
		themes: {
			light: {
				primary: "#f75c54", //[ROSSO CHIARO] colore secondario interfacce
				secondary: "#b92f34", //[ROSSO] Rosso principale scuro

				maingrey: "#8E8E8E", //[GRIGIO] colore testi principali
				title: "#3C4650", // [GRIGIO LOGO] colore testi titoli
				success: "#61CC71", // [VERDE HYPE] colore corretto / attivazione / password forte
				yellow: "#FBD966", //[GIALLO]
				warning: "#F07C3A", //[ARANCIONE] colore alert / password media
				error: "#C94646", // [ROSSO HYPE] colore errore / disattivazione / password debole
				savebarcolor: "#BDBDBD",
			},
			dark: {
				primary: "#2C41E5", //[BLU LOGO] colore primario
				secondary: "#3AA5F7", //[AZZURRO] colore secondario interfacce
				maingrey: "#8E8E8E", //[GRIGIO] colore testi principali
				title: "#3C4650", // [GRIGIO LOGO] colore testi titoli
				success: "#61CC71", // [VERDE HYPE] colore corretto / attivazione / password forte
				yellow: "#FBD966", //[GIALLO]
				warning: "#F07C3A", //[ARANCIONE] colore alert / password media
				error: "#C94646", // [ROSSO HYPE] colore errore / disattivazione / password debole
				savebarcolor: "#EEEEEE",
			},
		},
		options: {
			customProperties: true,
		},
	},
	icons: {
		iconfont: "fa",
	},
};

export default new Vuetify(opts);
